module.exports = __webpack_public_path__ + "static/media/logo.47f34d3d.jpg";